import styled, { css, keyframes } from 'styled-components';
import { Button } from '@/components/buttons/Button';
import { device } from '@/styles/helpers';

// Takes over the machine's spot after the rigged first win, so it shares
// the same anchor point instead of the machine's fixed aspect-ratio box.
export const ScOfferSlot = styled.div<{
  $visible: boolean;
}>`
  position: absolute;
  z-index: 1;
  left: 50%;
  bottom: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  height: auto;
  min-height: 390px;
  width: 600px;
  padding: 24px;
  border: 4px solid #fedf79;
  border-radius: 30px;
  background: linear-gradient(-6deg, #632668 16.458%, #6880cc 108.4%);
  transition:
    opacity 400ms ease-out ${({ $visible }) => ($visible ? '350ms' : '0ms')},
    transform 400ms ease-out ${({ $visible }) => ($visible ? '350ms' : '0ms')};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transform: translate(-50%, 50%)
    scale(${({ $visible }) => ($visible ? 1 : 0.7)});

  .front {
    position: static;
    height: 100%;
  }

  @media (${device.mobile}) {
    width: calc(100vw - 28px);
    height: auto;
    min-height: 390px;
    top: max(72px, calc(50% - 225px));
    bottom: auto;
    transform: translateX(-50%)
      scale(${({ $visible }) => ($visible ? 1 : 0.7)});
  }
`;

// Every keyframe re-states the translate(-50%, 50%) centering since a
// keyframe's `transform` replaces the whole property, not just scale.
const decorAppear = keyframes`
  from {
    transform: translate(-50%, 50%) scale(0);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 50%) scale(1);
    opacity: 1;
  }
`;

const decorPulse = keyframes`
  0%, 100% {
    transform: translate(-50%, 50%) scale(1);
  }
  50% {
    transform: translate(-50%, 50%) scale(1.05);
  }
`;

export const ScDecorFinish = styled.img<{ $active: boolean }>`
  position: absolute;
  z-index: 0;
  left: 50%;
  bottom: 50%;
  width: 1100px;
  max-width: 130vw;
  opacity: 0;
  transform: translate(-50%, 50%) scale(0);
  pointer-events: none;

  ${({ $active }) =>
    $active &&
    css`
      animation:
        ${decorAppear} 1800ms cubic-bezier(0.16, 1, 0.3, 1) both,
        ${decorPulse} 2000ms ease-in-out 1100ms infinite;
    `}

  @media (${device.mobile}) {
    height: 100vh;
    max-width: unset;
  }
`;

// FlipWrapper's .front/.back are absolutely positioned block boxes, so the
// flex/gap layout ScOfferSlot used to provide directly needs recreating here.
export const ScOfferCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  height: 100%;

  @media (${device.mobile}) {
    gap: 20px;
  }
`;

// Shared by WinInfo and SecondStageOffer's Prize.
export const ScOfferTitles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

// Shared by FirstStageOffer and SecondStageOffer.
export const ScOfferButton = styled(Button)`
  max-width: 280px;
  width: 100%;
  height: 48px;
  min-height: 48px;
  min-width: auto;
  border: none;
  background-color: ${({ theme }) => theme.mainColor};
  color: ${({ theme }) => theme.whiteColor};
  font-size: 16px;
  letter-spacing: 0.16px;

  .aware {
    background-color: #a94108;
  }
`;
